import "../constants.js";
import { useLocationsAndGroups } from "../hooks/useLocationsAndGroups.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationAndGroupNames.tsx
var LocationAndGroupNames = ({ listAll = true, locationAndGroupIds }) => {
	const { data, loading } = useLocationsAndGroups({ idFilter: locationAndGroupIds });
	if (!data?.locationsAndGroups && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.locationsAndGroups || !locationAndGroupIds?.length) return null;
	if (locationAndGroupIds.includes("loc-")) return /* @__PURE__ */ jsx("span", { children: "All Locations" });
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: data.locationsAndGroups[0].label
		}), /* @__PURE__ */ jsxs("div", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx("span", { children: data.locationsAndGroups.map(({ label }) => label).join(", ") });
};
//#endregion
export { LocationAndGroupNames };

//# sourceMappingURL=LocationAndGroupNames.js.map